import type { Group } from '@cheqroom/api';
import {
	type InfoFeatureFlags,
	type InfoNamespace,
	InfoProvider as SharedInfoProvider,
	type Translate,
} from '@cheqroom/components';
import type { usePermissions } from '@cheqroom/hooks';
import type { ComponentType, FC, PropsWithChildren, ReactNode } from 'react';

// Re-typed with this app's React 18 `FC` for the same cross-workspace reason as `ItemInfo` (see
// `ItemInfo/ItemInfo.tsx`).

type PermissionsUser = Parameters<typeof usePermissions>[0]['user'];

// Re-declared with this app's React 18 types, unlike `InfoFeatureFlags`: a component flows *out* to the
// package (it is called with the package's React 19 `children`), which is the direction that fails.
export interface InfoComponents {
	Link?: ComponentType<{ href: string; children?: ReactNode }>;
}

export interface InfoConfig {
	user?: PermissionsUser;
	workspace?: Pick<Group, 'profile' | 'limits' | 'itemFlags' | 'itemTypes'> | null;
	useTranslate: (ns: InfoNamespace) => Translate;
	currency?: string | null;
	locale?: string;
	featureFlags?: InfoFeatureFlags;
	components?: InfoComponents;
}

export type { InfoNamespace };

export const InfoProvider = SharedInfoProvider as unknown as FC<PropsWithChildren<InfoConfig>>;
